<a
  class="action-menu-toggle-button"
  aria-haspopup="true"
  aria-expanded="false"
  [sotiPopupTriggerFor]="actionPopup"
  (click)="$event.stopImmediatePropagation()"
>
  <span class="hd-icon hd-icon-more"></span>
</a>
<soti-popup #actionPopup="sotiPopup" position="endBottom">
  <div>
    <ul class="action-menu-list">
      <li
        class="action-menu-list-item"
        [class.splitter]="listItem.customProperty"
        *ngFor="let listItem of dropDownItems"
        (click)="performAction($event, listItem)"
      >
        <span *ngIf="listItem.glyphicon" class="{{ listItem.glyphicon }} list-item-glyphicon"></span>
        <span *ngIf="listItem.caption" class="list-item-caption">{{ listItem.caption }}</span>
      </li>
    </ul>
  </div>
</soti-popup>
